import React from 'react';

import './index.scss';
import utils from '../../../../utils';
import { REACT_APP_IMAGES_PUBLIC_URL } from '../../../../config';

import { ReactComponent as WhiteLogo } from '../../../../img/svg/Logos/WhiteLogo.svg';

function StarStakeNftCard({
  cardData = {},
  fromPath = '/MarketHub',
  htmlEditableView = false
}) {
  const {
    snftTitle = '',
    snftCategory = '',
    snftImagePath = '',
    snftBrandLogo = '',
    nickName = '',
    snftNumber = 0
  } = cardData;

  if (!htmlEditableView && snftImagePath) {
    return (
      <div className="snft-card-canvas-img">
        <img src={utils.getImagePathFromURL(snftImagePath)} alt="" />
      </div>
    );
  }

  return (
    <div className="snft-card-wrapper">
      <div className="snft-card-bg">
        <div className="top-logo-section">
          <div>
            <WhiteLogo className="snft-ss-logo" />
            <div className="snft-brand-club font-family-gemsbuck">
              Campaign Club
            </div>
          </div>
          {snftBrandLogo && (
            <div className="snft-seals-section">
              <img src={snftBrandLogo} alt="snft-img" />
            </div>
          )}
        </div>
        <div className="snft-main-img">
          <img
            src={
              snftImagePath ||
              REACT_APP_IMAGES_PUBLIC_URL +
                '/stakehubSNFTImages/Placeholder.png'
            }
            style={snftImagePath ? {} : { scale: '1.4' }}
            alt="snft-img"
          />
        </div>
        <h5 className="text-white two-line-title mb-0 overflow-wrap-word font-family-gemsbuck">
          {snftTitle || '---'}
        </h5>
        <div className="top-logo-section">
          <div className="d-flex flex-column" style={{ gap: '7px' }}>
            <p className="snft-nickname">{nickName || '---'}</p>
            <div>
              <p className="snft-category">Category</p>
              <p className="snft-category-type">{snftCategory || '--'}</p>
            </div>
          </div>
          <p className="snft-edition-num">{snftNumber || '#001'}</p>
        </div>
      </div>
    </div>
  );
}

export default StarStakeNftCard;
